export default "__VITE_ASSET__DrjkLWnn__";